import React, { useState } from "react";

export default function Inquiry() {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        parentName: "",
        contactNumber: "",
        admissionClass: "",
        email: "",
        captcha: "",
    });

    // Helper to generate captcha
    function generateCaptcha() {
        return Math.random().toString(36).substring(2, 8).toUpperCase();
    }

    const [generatedCaptcha, setGeneratedCaptcha] = useState(generateCaptcha());
    const [status, setStatus] = useState({ type: "", message: "" });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ type: "", message: "" });

        // Captcha Validation
        if (formData.captcha.toUpperCase() !== generatedCaptcha) {
            setStatus({ type: "error", message: "Captcha does not match!" });
            return;
        }

        try {

            const res = await fetch("https://cms.maitretech.com/seedlingschoolbhopal/items/inquiry2", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    first_name: formData.firstName,
                    last_name: formData.lastName,
                    parents_name: formData.parentName,
                    contact_number: formData.contactNumber,
                    class: formData.admissionClass,
                    email_id: formData.email,
                }),
            });
            const data = await res.json();
            if (res.ok) {
                setGeneratedCaptcha(generateCaptcha());

                setFormData({
                    firstName: "",
                    lastName: "",
                    parentName: "",
                    contactNumber: "",
                    admissionClass: "",
                    email: "",
                    captcha: "",
                });
                setStatus({ type: "success", message: "Inquiry submitted successfully!" });
            } else {
                const errMsg = data?.errors?.[0]?.message || "Submission failed";
                setStatus({ type: "error", message: `Error: ${errMsg}` });
            }
        } catch (err) {
            setStatus({ type: "error", message: "Network error. Please try again later." });
        }
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.title}>School Inquiry Form</h2>
            <form onSubmit={handleSubmit} style={styles.form}>
                <input type="text" name="firstName" placeholder="First Name of the Child" value={formData.firstName} onChange={handleChange} required style={styles.input} />
                <input type="text" name="lastName" placeholder="Last Name of the Child" value={formData.lastName} onChange={handleChange} required style={styles.input} />
                <input type="text" name="parentName" placeholder="Parent's Name" value={formData.parentName} onChange={handleChange} required style={styles.input} />
                <input type="int" name="contactNumber" placeholder="Contact Number" value={formData.contactNumber} onChange={handleChange} required style={styles.input} />

                <select name="admissionClass" value={formData.admissionClass} onChange={handleChange} required style={styles.input}>
                    <option value="">Admission in Class</option>
                    {["Play Group", "Nursery", "KG", "Class 1", "Class 2", "Class 3", "Class 4", "Class 5", "Class 6", "Class 7", "Class 8"].map(cls => (
                        <option key={cls} value={cls}>{cls}</option>
                    ))}
                </select>

                <input type="email" name="email" placeholder="Email ID" value={formData.email} onChange={handleChange} required style={styles.input} />

                <div style={styles.captchaContainer}>
                    <span style={styles.captcha}>{generatedCaptcha}</span>
                    <input type="text" name="captcha" placeholder="Enter Captcha" value={formData.captcha} onChange={handleChange} required style={{ ...styles.input, flex: 1 }} />
                    <button type="button" onClick={() => setGeneratedCaptcha(generateCaptcha())} style={styles.refreshBtn}>Refresh</button>
                </div>

                <button type="submit" style={styles.button}>Submit Inquiry</button>

                {status.message && (
                    <p style={{
                        ...styles.message,
                        color: status.type === "success" ? "#28a745" : "#dc3545"
                    }}>
                        {status.message}
                    </p>
                )}
            </form>
        </div>
    );
}

const styles = {
    container: { maxWidth: "550px", margin: "50px auto", padding: "30px 25px", background: "linear-gradient(145deg, #fefefe, #e0f7ff)", borderRadius: "15px", boxShadow: "0 12px 30px rgba(0,0,0,0.15)", fontFamily: "sans-serif" },
    title: { textAlign: "center", marginBottom: "25px", color: "#007bff", fontSize: "26px", fontWeight: "600" },
    form: { display: "flex", flexDirection: "column", gap: "18px" },
    input: { padding: "14px 16px", fontSize: "16px", borderRadius: "10px", border: "1px solid #ccc", outline: "none", width: "100%" },
    button: { padding: "15px", fontSize: "18px", borderRadius: "12px", border: "none", background: "linear-gradient(90deg, #007bff, #00bfff)", color: "#fff", cursor: "pointer", fontWeight: "600" },
    captchaContainer: { display: "flex", gap: "12px", alignItems: "center" },
    captcha: { padding: "12px 18px", fontSize: "16px", background: "#007bff", color: "#fff", borderRadius: "10px", fontWeight: "600", userSelect: "none" },
    refreshBtn: { padding: "10px 12px", fontSize: "14px", borderRadius: "8px", border: "none", background: "#00bfff", color: "#fff", cursor: "pointer" },
    message: { marginTop: "15px", textAlign: "center", fontWeight: "600" },
};